import { zodResolver } from '@hookform/resolvers/zod';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { Button } from 'components/Button';
import { Code } from 'components/Code';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { GameSchema, type Game, type GameRecord } from 'shared/modelTypes/game';
import { GameForm } from 'forms/GameForm';
import { emitMessage } from 'engine/api';
import { toast } from 'sonner';
import { X } from 'lucide-react';
import type { SkinRecord } from 'shared/modelTypes/skin';
import { FilePickerProvider } from 'components/FilePickerProvider';

export const Route = createFileRoute('/dashboard/games/edit/$id')({
	component: RouteComponent,
	loader: async ({ params }) => {
		return {
			skinsResponse: await emitMessage({ kind: 'skin-list' }),
			gameResponse: await emitMessage({ kind: 'game-find', id: params.id }),
			directory: (await emitMessage({ kind: 'media-list-directory', folderId: null })).media,
		};
	},
});

function RouteComponent() {
	const data = Route.useLoaderData();

	return (
		<div>
			{!data.gameResponse.game && <span>Game not found</span>}

			<FilePickerProvider startDirectory={data.directory!}>
				{data.gameResponse.game && <GameUpdateForm game={data.gameResponse.game!} skins={data.skinsResponse.skins ?? []} />}
			</FilePickerProvider>
		</div>
	);
}

function GameUpdateForm({ skins, game }: { skins: SkinRecord[]; game: GameRecord }) {
	const methods = useForm<Game>({
		// @ts-expect-error zodResolver type inference seems to be bad
		resolver: zodResolver(GameSchema),
		defaultValues: game.game,
	});

	const err = methods.formState.errors;

	const router = useRouter();
	const [result, setResult] = useState<Game | undefined>();
	const [res, setRes] = useState<Promise<unknown> | undefined>();

	const skinOptions = skins.map((s) => ({ value: s.id, label: s.skin.name }));
	// const onSubmit = (data: GameTask) => {
	// 	setResult(data);
	// };

	const onSubmit = async (data: Game) => {
		setResult(data);

		const r = emitMessage({ kind: 'game-update', game: { id: game.id, game: data } });
		setRes(r);
		const response = await r;
		if (response.success) {
			router.invalidate();
			router.navigate({ to: '/dashboard/games' });
		} else {
			setRes(undefined);
			toast('server did not save game', { icon: <X /> });
		}
	};

	console.log('errors', err);
	return (
		<FormProvider {...methods}>
			<form
				style={{ opacity: res ? '0.4' : '1' }}
				className="flex flex-col gap-3"
				// @ts-expect-error zodResolver type inference seems to be bad
				onSubmit={methods.handleSubmit(onSubmit)}
			>
				<GameForm skinOptions={skinOptions} label="Edit Game" />
				<Button type="submit">Submit</Button>
			</form>
			{result && (
				<Code block className="mt-4">
					{JSON.stringify(result, null, 2)}
				</Code>
			)}
		</FormProvider>
	);
}
